/**
 * [pug template]
 */
<template lang="pug">
  span(:id="name", :name="name", v-text="text", @click="onClick")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'button-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number],
      default: ''
    },
    onClick: {
      type: Function,
      default: function () {}
    }
  },
  data: function () {
    return {
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ButtonComponent.vue?735a4b4b